import { apiClient } from "../apiClient";

/** Các con số "việc còn tồn" của một học kỳ / năm học (chuông thông báo). */
export interface IThongKeCanXuLy {
  bo_sung_hoc_phan: number;
  chua_xuat_hoa_don: number;
  muc_thu_chua_duyet: number;
  hoc_phan_gia_0: number;
  con_tien_trong_vi: number;
  thoi_hoc_con_no: number;
  rut_hoc_phan: number;
  huy_dang_ky: number;
  thu_thua: number;
  mien_giam_cho_duyet: number;
  thi_lai_cho_duyet: number;
  hoc_bu_cho_duyet: number;
  hoc_lai_cho_duyet: number;
  tong: number;
}

export const thongKeCanXuLyApi = {
  Select: (hoc_ky: number, nam_hoc: string) =>
    apiClient.get(
      `dashboard/thong-ke-can-xu-ly?hoc_ky=${hoc_ky}&nam_hoc=${encodeURIComponent(nam_hoc)}`,
    ),
};
